import React from 'react'
import Hero from '../../components/Hero';
import { useIntl } from 'react-intl';
import NOMLinkBoxRow from '../../components/NOMLinkBoxRow';

export type NOM_016_SCFI_1993Props = {};

const NOM_016_SCFI_1993: React.FC<NOM_016_SCFI_1993Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero 
        bgImage={'/img/electronics-rs.jpg'} 
        heading={intl.formatMessage({
          id: "electronics",
          defaultMessage: "Electronics"
        })}
        subHeading={"NOM-016-SCFI-1993"} />
      <NOMLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-6 !pt-8">
        <h2 className="text-2xl text-secondary font-bold">NOM-016-SCFI-1993</h2>
        <p className='text-md font-bold'>
          {
            intl.formatMessage({
              id: 'office_elec',
              defaultMessage: 'Electronic devices for office use and powered by different sources of electrical energy Safety requirements and test methods.'
            })
          }
        </p>
        <div className="flex flex-col gap-4 mt-4 mb-16">
          <p>
            {
              intl.formatMessage({
                id: 'nom016scfi1993_1',
                defaultMessage: 'It includes electronic and electromechanical devices for use in offices and schools that are used to carry out various jobs, typical of said places. Establishes the security requirements, as well as the test methods that must be met.'
              })
            }
          </p>
          <p>
            {
              intl.formatMessage({
                id: 'nom016scfi1993_2',
                defaultMessage: 'Such devices are considered to be electronic typewriters, copying and/or duplicating machines for reproducing documents, electronic calculators, electronic blackboards, telefacsimile devices and other devices for use in offices and schools.'
              })
            }
          </p>
          
        </div>
        <div className="w-full">
          <img src="/img/office-elect-nom-1993.jpg" alt="NOM-016-SCFI-1993 Office Devices" />
        </div>
      </div>
    </div>
  );
}

export default NOM_016_SCFI_1993;